import { TriggeredMessagesTableContainer } from './components/triggered-messages-table.container';

export const TriggeredMessagesList = () => {
  return <TriggeredMessagesTableContainer />;
};
